export class CustPortalError extends Error {
    public data: {
        error: string
    };
    public status: number;
};

export class LoginBean {
    public token: string;
    public propertymap: {[key: string]: string};
    public messages: Array<string>;
    public warnings: Array<string>;
    public errors: Array<string>;
}

export class IJwtPayload {
    public userId: string;
    public username: string;
    public authorizations: Array<string>;
}

export class Order {
    public orderid: string;
    public documentno: string;
    public dateordered: string;
    public qtyordered: number;
    public qtydelivered: number;
    public qtyinvoiced: number;
    public qtyproduced: number;
    public pieChart: any;
    public inouts: Array<Inout>;
    public invoices: Array<Invoice>;
    public documents: Array<OrderDocument>;
}

export class Inout {
    public id: string;
    public name: string;
    public movementdate: string;
    public url: string;
}

export class Invoice {
    public invoiceid: string;
    public documentno: string;
    public dateinvoiced: string;
    public url: string;
    public orders: Array<Order>;
}

export class OrderDocument {
    public documentid: string;
    public name: string;
    public uploaddate: string;
    public documents: Array<any>;
    public url: string;
    public canViewUpload: boolean;
}

export class OrderLine {
    public orderlineid: string;
    public documentno: string;
    public nameprod: string;
    public dateordered: string;
    public qtyordered: number;
    public qtydelivered: number;
    public qtyinvoiced: number;
}

export class Stock {
    public prodname: string;
    public productid: number;
    public prodvalue: number;
    public qtyavailable: number;
    public qtyonhand: number;
    public qtyordered: number;
    public qtyreserved: number;
}